import React, { Suspense } from "react";

import { SpinnerFullScreen } from "../../components/SpinnerFullScreen";
import TasksRoute from "./TasksRoute";

// const TaskRouteWithContext = React.lazy(() => import("./TasksRoute"));

export const TaskRouteWithLazy: React.FC = () => {
  return (
    <Suspense fallback={<SpinnerFullScreen />}>
      <TasksRoute />
    </Suspense>
  );
};
